import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { type PropType } from 'vue';

import { modalVariant, type ModalVariant } from '@exchange/libs/modals/src';


export default /*#__PURE__*/_defineComponent({
  __name: 'TransactionFlow',
  props: {
  name: { type: String, required: true },
  until: { type: Function, required: true },
  variant: { type: String as PropType<ModalVariant>, default: modalVariant.light },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  const _component_ot_loading_indicator = _resolveComponent("ot-loading-indicator")!

  return (_openBlock(), _createBlock(_component_ot_loading_indicator, {
    class: _normalizeClass(['transaction-flow', `transaction-flow__${__props.name}`, `transaction-flow__${__props.variant}`]),
    until: __props.until,
    "is-black": __props.variant === 'light'
  }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "content", {
        contentClass: "transaction-flow__content",
        emptyContentClass: "transaction-flow__empty-content"
      })
    ]),
    _: 3
  }, 8, ["class", "until", "is-black"]))
}
}

})